
// export const PENDING ="PENDING";
// export const ERROR ="ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const GET_EMAIL_ID_BY_ID = "GET_EMAIL_ID_BY_ID";